/**
 * The colour theme a person chose, or none (follow the system).
 *
 * Kept in a cookie rather than on the account: it is a property of the
 * device as much as the person — dark on the phone at night, light on the
 * school computer — and a cookie is what the server can read to put
 * `data-theme` on `<html>` in the first byte, so the page never paints in
 * the wrong theme and then flips.
 */
export const THEME_COOKIE = 'uniap_theme'

export type ThemeChoice = 'system' | 'light' | 'dark'

/** A stored value, or `system` for anything else (absent, stale, tampered). */
export function parseTheme(value: string | undefined | null): ThemeChoice {
  return value === 'light' || value === 'dark' ? value : 'system'
}

/** Apply a choice in the browser: the attribute now, the cookie for next time. */
export function applyTheme(choice: ThemeChoice) {
  const root = document.documentElement
  if (choice === 'system') {
    delete root.dataset.theme
    document.cookie = `${THEME_COOKIE}=; path=/; max-age=0; samesite=lax`
  } else {
    root.dataset.theme = choice
    document.cookie = `${THEME_COOKIE}=${choice}; path=/; max-age=31536000; samesite=lax`
  }
}
